import React, { useCallback } from "react";
import { useEditorStore } from "../../../../state/editorStore";
import WatermarkLeftPanelOverlays from "../Popup/WatermarkLeftPanelOverlays";
import { DEFAULT_WATERMARK_SETTINGS } from "../Popup/watermarkSettings";

/** Editor left-panel Color / Position overlays driven by the canvas text toolbar. */
const EditorWatermarkLeftPanelOverlays = () => {
  const watermark = useEditorStore((s) => s.object.watermark);
  const setWatermark = useEditorStore((s) => s.setWatermark);

  const mergeWatermark = useCallback(
    (updates) => {
      const prev = useEditorStore.getState().object.watermark || {};
      setWatermark({ ...prev, ...updates, enabled: true });
    },
    [setWatermark]
  );

  if (!watermark?.enabled) return null;

  const settings = {
    ...DEFAULT_WATERMARK_SETTINGS,
    ...watermark,
  };

  return (
    <WatermarkLeftPanelOverlays
      settings={settings}
      onChange={mergeWatermark}
      positionStageSelector=".editor-page__canvas-stack"
    />
  );
};

export default EditorWatermarkLeftPanelOverlays;
